import tenant from "../pages/tenantManagement/index";
import tenantManagement from "../pages/tenantManagement/tenantManagement";
import tenantAdministrator from "../pages/tenantManagement/tenantAdministrator"
import wikiManage from "../pages/wikiManage/index";


import menu from '../pages/menuManagement/index'
import menuFirst from "../pages/menuManagement/menuFirst";
import menuSecond from "../pages/menuManagement/menuSecond";
import menuThird from "../pages/menuManagement/menuThird";
import logo from '../../../components/logo.vue'
import admin from '../pages/admin'

import indexGroup from "../pages/indexManagement/indexGroup";
import indexManage from "../pages/indexManagement/indexManage";

// const firstIndex = () => import('../pages/indexManagement/firstIndex');
import firstIndex from '../pages/indexManagement/firstIndex';

// import $watermark from '../components/common/watermark';

var routes = [{
      path: "/",
      component: admin,
      redirect: "/menu",
      children: [{
        path: "/index",
        redirect: '/menu/first',
      },{
          path: "/menu",
          name: "menu",
          component: menu,
          redirect: '/menu/first',
          meta: {
            title: "菜单管理",
            isMenu: false,
            upMenuTitle: [{ title: '系统管理', url: '', isMenu: false, }],
          },
          children: [{
              path: "/menu/first",
              name: "menuFirst",
              component: menuFirst,
              meta: {
                title: "一级菜单管理",
              }
            },
            {
              path: "/menu/second",
              name: "menuSecond",
              component: menuSecond,
              meta: {
                title: "二级菜单管理",
                upMenuTitle: [{ title: '一级菜单管理', url: '/menu/first' }],
              }
            },
            {
              path: "/menu/third",
              name: "menuThird",
              component: menuThird,
              meta: {
                title: "三级菜单管理",
                upMenuTitle: [{ title: '一级菜单管理', url: '/menu/first' }, { title: '二级菜单管理', url: '/menu/second' }],
              }
            },
          ]
        },

        {
          path: "/tenant",
          name: "tenantManage",
          component: tenant,
          redirect: '/tenant/management',
          meta: {
            title: "系统管理",
            isMenu: false,
          },
          children: [{
              path: "/tenant/management",
              name: "management",
              component: tenantManagement,
              meta: {
                title: "租户管理",
              }
            },
            {
              path: "/tenant/admin",
              name: "admin",
              component: tenantAdministrator,
              meta: {
                title: "租户管理员",
                upMenuTitle: [{ title: '租户管理', url: '/tenant/management' }],
              },
            }
          ]
        },
        {
          path: "/content/manage",
          name: "wikiManage",
          component: wikiManage,
          // redirect: '/wiki/manage',
          meta: {
            title: "百科管理",
            isMenu: false,
          },
        },
        // 索引管理
        {
          path: "/indexManage",
          name: "/indexManage",
          redirect: "/indexManage/group",
          component: indexManage,
          meta: {
            title: "索引管理",
            isMenu: false,
          },
          children: [{
            path: "/indexManage/group",
            name: "indexManage",
            component: indexGroup,
            meta: {
              title: "一级索引"
            },
          },
            {
              path: '/indexManage/:id',
              component: firstIndex,
              name: "indexManageRef",
              meta: {
                title: "索引管理",
              },
            },
          ],
        },
      ],
    },

    {
      path: "/logo",
      name: "logo",
      component: logo,
      meta: {
        title: "登录",
      },
    }
  ]

let router = new VueRouter({
  mode: "history",
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return { x: 0, y: 0 };
    }
  },

  routes,
});

router.beforeEach((to, from, next) => {
  console.log(to);
  // 判断touter.app是否为null 否则man端浏览器后退报错
  if (!router.app){
    return
  }  if(to.matched.length == 0){
    next({
      path: '/index',
      query: {
        ...to.query,
      },
    });
    return;
  }
  next();
});
window.dsRouter = router;

export default router
export {
  routes
}
